import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const PassengerInfoForm = ({ formData, setFormData, errors }) => {
  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 shadow-sm space-y-4 md:space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b border-border">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Users" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl lg:text-2xl font-heading font-bold text-foreground">
            Passenger Information
          </h2>
          <p className="text-sm text-muted-foreground">
            Enter contact and passenger details
          </p>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Full Name"
            type="text"
            placeholder="Enter your full name"
            value={formData?.fullName}
            onChange={(e) => handleInputChange('fullName', e?.target?.value)}
            error={errors?.fullName}
            required
          />

          <Input
            label="Mobile Number"
            type="tel"
            placeholder="Enter 10-digit mobile number"
            value={formData?.mobile}
            onChange={(e) => handleInputChange('mobile', e?.target?.value)}
            error={errors?.mobile}
            required
            pattern="[0-9]{10}"
            maxLength={10}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Email Address"
            type="email"
            placeholder="your.email@example.com"
            value={formData?.email}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            error={errors?.email}
            required
            description="Booking confirmation will be sent here"
          />

          <Input
            label="Number of Passengers"
            type="number"
            placeholder="Enter number"
            value={formData?.passengers}
            onChange={(e) => handleInputChange('passengers', e?.target?.value)}
            error={errors?.passengers}
            required
            min={1}
            max={17}
          />
        </div>

        <Input
          label="Pickup Address"
          type="text"
          placeholder="Enter complete pickup address"
          value={formData?.pickupAddress}
          onChange={(e) => handleInputChange('pickupAddress', e?.target?.value)}
          error={errors?.pickupAddress}
          required
          description="Include landmark for easy identification"
        />

        <Input
          label="Drop Address"
          type="text"
          placeholder="Enter complete drop address"
          value={formData?.dropAddress}
          onChange={(e) => handleInputChange('dropAddress', e?.target?.value)}
          error={errors?.dropAddress}
          required
          description="Final destination address"
        />

        <div className="p-4 bg-muted/50 rounded-lg border border-border">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="text-primary mt-0.5" />
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-foreground mb-1">
                Important Information
              </h4>
              <ul className="text-xs text-muted-foreground space-y-1">
                <li>• Please ensure mobile number is active for driver coordination</li>
                <li>• Booking confirmation will be sent via SMS and email</li>
                <li>• Provide accurate pickup address to avoid delays</li>
                <li>• Additional charges may apply for extra luggage or stops</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassengerInfoForm;